import React from 'react';
import cn from 'classnames';

import { selectReactionsCount } from 'client/redux/pubnub/selectors';
import { useGAEventCommonProps } from 'client/hooks/ga-event-common-props';
import { thousandSeparator } from 'utils/thousand-separator';
import { useAppSelector } from 'client/hooks';
import { EMOJI_TYPES } from 'client/types';
import { analytics } from 'client/utils/analytics';

import Icon from '../../Icon';

import css from './EmotionsMenu.module.scss';

interface Props {
  className?: string;
  closeMenu: () => void;
  setEmoji: (src: EMOJI_TYPES) => void;
}

const EmotionsMenu: React.FC<Props> = (props) => {
  const { className = '', closeMenu, setEmoji } = props;
  const { common } = useGAEventCommonProps();
  const reactionsCount = useAppSelector(selectReactionsCount);

  const clickOnEmoji = (e: React.MouseEvent<HTMLDivElement>) => {
    const { type } = e.currentTarget.dataset;

    if (type) {
      setEmoji(type as EMOJI_TYPES);

      analytics.gtag.event('audio_chat_user_interaction', {
        ...common,
        emotion: type,
      });
    }
  };

  const clickOnOverlay = () => {
    closeMenu();
  };

  return (
    <div className={cn(css.emotionsMenu, className)} data-testid="emotions-menu">
      <div className={css.overlay} onClick={clickOnOverlay} data-testid="emotions-overlay"></div>
      <div className={css.menu}>
        <div className={css.btn} onClick={clickOnEmoji} data-type={EMOJI_TYPES.LIKE}>
          <Icon className={css.icon} type={EMOJI_TYPES.LIKE} />
          {reactionsCount && reactionsCount[EMOJI_TYPES.LIKE] > 0 && (
            <span className={css.count}>({thousandSeparator(reactionsCount[EMOJI_TYPES.LIKE])})</span>
          )}
        </div>
        <div className={css.btn} onClick={clickOnEmoji} data-type={EMOJI_TYPES.HEART}>
          <Icon className={css.icon} type={EMOJI_TYPES.HEART} />
          {reactionsCount && reactionsCount[EMOJI_TYPES.HEART] > 0 && (
            <span className={css.count}>({thousandSeparator(reactionsCount[EMOJI_TYPES.HEART])})</span>
          )}
        </div>
        <div className={css.btn} onClick={clickOnEmoji} data-type={EMOJI_TYPES.SMILE}>
          <Icon className={css.icon} type={EMOJI_TYPES.SMILE} />
          {reactionsCount && reactionsCount[EMOJI_TYPES.SMILE] > 0 && (
            <span className={css.count}>({thousandSeparator(reactionsCount[EMOJI_TYPES.SMILE])})</span>
          )}
        </div>
        <div className={css.btn} onClick={clickOnEmoji} data-type={EMOJI_TYPES.WONDER}>
          <Icon className={css.icon} type={EMOJI_TYPES.WONDER} />
          {reactionsCount && reactionsCount[EMOJI_TYPES.WONDER] > 0 && (
            <span className={css.count}>({thousandSeparator(reactionsCount[EMOJI_TYPES.WONDER])})</span>
          )}
        </div>
        <div className={css.btn} onClick={clickOnEmoji} data-type={EMOJI_TYPES.CRY}>
          <Icon className={css.icon} type={EMOJI_TYPES.CRY} />
          {reactionsCount && reactionsCount[EMOJI_TYPES.CRY] > 0 && (
            <span className={css.count}>({thousandSeparator(reactionsCount[EMOJI_TYPES.CRY])})</span>
          )}
        </div>
        <div className={css.btn} onClick={clickOnEmoji} data-type={EMOJI_TYPES.ANGRY}>
          <Icon className={css.icon} type={EMOJI_TYPES.ANGRY} />
          {reactionsCount && reactionsCount[EMOJI_TYPES.ANGRY] > 0 && (
            <span className={css.count}>({thousandSeparator(reactionsCount[EMOJI_TYPES.ANGRY])})</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmotionsMenu;
